import { Injectable } from '@angular/core';
import { Key, NgxIndexedDBService } from 'ngx-indexed-db';
import { IndexDb } from '../IndexDb.interface';
import { IndexDbHandler } from './handler/index-db-handler';
import { Stores } from './stores.enum';

@Injectable({
  providedIn: 'root',
})
export class IndexDbService {
  moduleStructure = new IndexDbHandler(Stores.moduleStructure, this.dbService);
  shoppingCart = new IndexDbHandler(Stores.shoppingCart, this.dbService);
  constructor(private dbService: NgxIndexedDBService) {}
  add(
    store: Stores,
    key: IDBValidKey,
    value: any,
    callback: (result: any) => void
  ) {
    switch (store) {
      case Stores.moduleStructure:
        this.moduleStructure.InvokeMethod('addOrUpdate', key, value, (result) =>
          callback(result)
        );
        break;
      case Stores.shoppingCart:
        this.shoppingCart.InvokeMethod('addOrUpdate', key, value, (result) =>
          callback(result)
        );
        break;
      default:
        break;
    }
  }
  addBulk(store: Stores, valuesArray: any[], callback: (result: any) => void) {}
  delete(store: Stores, key: Key, callback: (result: any) => void) {}
  bulkDelete(store: Stores, keys: Key[], callback: (result: any) => void) {}
  getByKey(store: Stores, key: IDBValidKey, callback: (result: any) => void) {
    switch (store) {
      case Stores.moduleStructure:
        this.moduleStructure.InvokeMethod('getByKey', key, (result) =>
          callback(result)
        );
        break;
      case Stores.shoppingCart:
        this.shoppingCart.InvokeMethod('getByKey', key, (result) =>
          callback(result)
        );
        break;
      default:
        break;
    }
  }
  bulkGet(
    store: Stores,
    keys: IDBValidKey[],
    callback: (result: any) => void
  ) {}
  getAll(store: Stores, callback: (result: any) => void) {}
  getByIndex(
    store: Stores,
    columnName: string,
    key: IDBValidKey,
    callback: (result: any) => void
  ) {}
  update(store: Stores, value: any, callback: (result: any) => void) {}
  updateByKey(
    store: Stores,
    value: any,
    key: IDBValidKey,
    callback: (result: any) => void
  ) {}
  count(store: Stores, callback: (result: any) => void) {}
  clear(store: Stores, callback: (result: any) => void) {}
  InvokeMethod(store: Stores, methodName: string, ...params: any) {}
}
